import { render, staticRenderFns } from "./instanceList.vue?vue&type=template&id=64ba036a&"
import script from "./instanceList.vue?vue&type=script&lang=js&"
export * from "./instanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports